import { render } from "./PhotoCarousel.vue?vue&type=template&id=9f3dcd8c&scoped=true&ts=true"
import script from "./PhotoCarousel.vue?vue&type=script&lang=ts"
export * from "./PhotoCarousel.vue?vue&type=script&lang=ts"

import "./PhotoCarousel.vue?vue&type=style&index=0&id=9f3dcd8c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f3dcd8c"]])

export default __exports__